import { queryClient } from '@/shared/api';
import { useVerifySubscriptionCheckout } from '@/shared/api/generated/subscriptions';

export const useVerifyCheckout = () => {
  return useVerifySubscriptionCheckout({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['/current-user'], refetchType: 'all' });
      },
    },
  });
};
